<template>
  <!-- <div class="homepage-hero-module">
    <div class="video-container">
      <div :style="fixStyle" class="filter">
        <el-scrollbar>
          <el-container>
            <el-header>
              <Header></Header>
            </el-header>

            <router-view />

            <el-footer>
              <Footer></Footer>
            </el-footer>
          </el-container>
        </el-scrollbar>
      </div>
      <video :style="fixStyle" autoplay loop class="fillWidth" v-on:canplay="canplay">
        <source src="./assets/coverr-sunrise-1563948708950.mp4" type="video/mp4" />浏览器不支持 video 标签，建议升级浏览器。
      </video>
      <div class="poster hidden" v-if="!vedioCanPlay">
        <img :style="fixStyle" src="coverr-sunrise-1563948708950.jpg" alt />
      </div>
    </div>
  </div> -->
  <div id="app">
    
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      
        <router-view />
    
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";
export default {
  components: {
    Footer,
    Header
  },
  name: "App",
  data() {
    return {
      vedioCanPlay: false,
      fixStyle: ""
    };
  },
  methods: {
    canplay() {
      this.vedioCanPlay = true;
    }
  },
  mounted: function() {
    window.onresize = () => {
      const windowWidth = document.body.clientWidth;
      const windowHeight = document.body.clientHeight;
      const windowAspectRatio = windowHeight / windowWidth;
      let videoWidth;
      let videoHeight;
      if (windowAspectRatio < 0.5625) {
        videoWidth = windowWidth;
        videoHeight = videoWidth * 0.5625;
        this.fixStyle = {
          height: windowWidth * 0.5625 + "px",
          width: windowWidth + "px",
          "margin-bottom": (windowHeight - videoHeight) / 2 + "px",
          "margin-left": "initial"
        };
      } else {
        videoHeight = windowHeight;
        videoWidth = videoHeight / 0.5625;
        this.fixStyle = {
          height: windowHeight + "px",
          width: windowHeight / 0.5625 + "px",
          "margin-left": (windowWidth - videoWidth) / 2 + "px",
          "margin-bottom": "initial"
        };
      }
    };
    window.onresize();
  }
};
</script>

<style>
.homepage-hero-module,
.video-container {
  position: relative;
  height: 100vh;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.video-container .poster img,
.video-container video {
  z-index: 0;
  position: absolute;
}

.video-container .filter {
  z-index: 1;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
}

#app {
  font-family: "Hiragino Sans GB", "WenQuanYi Micro Hei", "Lucida Sans",
    "Lucida Sans Regular", "Lucida Grande", "Lucida Sans Unicode",
    "Microsoft YaHei", sans-serif;
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #12181f;
}
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}

.el-main {
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  overflow: ;
  box-sizing: border-box;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue